import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { GET_URL } from '@utils/api/endpoints';
import { QueryKeys } from '@utils/api/query-keys';
import { AxiosError } from 'axios';

export type TranslationDocument = {
  id: string;
  language: string;
  filename: string;
  type: string;
  created: string;
};

export type DocumentTranslationsResult = {
  source: TranslationDocument;
  translations: TranslationDocument[];
};

type DocumentTranslationsResponse = {
  result: DocumentTranslationsResult;
};

async function getDocumentTranslations(
  sessionId: string,
  documentId: string
): Promise<DocumentTranslationsResponse> {
  const { data } = await Axios.get(
    GET_URL(sessionId, documentId).documentTranslations
  );
  return data;
}

export function useGetDocumentTranslations(
  sessionId?: string,
  documentId?: string
) {
  return useQuery<DocumentTranslationsResponse, AxiosError>(
    QueryKeys.documentTranslations(sessionId!, documentId!),
    () => getDocumentTranslations(sessionId!, documentId!),
    {
      enabled: !!sessionId && !!documentId,
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false
    }
  );
}
